export default __webpack_public_path__ + "static/public-support-59921a3e05954ff47eda63787f316b18.webp";